import { RouteConfig } from "vue-router";
import { REmployeesBrowse } from "@/modules/Employees/Browse/REmployeesBrowse";
import { REmployeesTemplate } from "@/modules/Employees/Template/REmployeesTemplate";

export const REmployerEmployees: RouteConfig = {
  path: "employees",
  component: () =>
    import(
      /* webpackChunkName: "employer-employees" */
      "./VEmployerEmployees.vue"
    ),
  meta: {
    title: "Employees",
    icon: "people-outline",
    newIcon: "users-group",
    isChild: true,
  },
  children: [REmployeesBrowse, REmployeesTemplate],
};
